/* unplugin-vue-components disabled */
import Column from 'primevue/column'
import {DataTable} from 'components/data-table'
import AddModal from './add-modal.vue'
import $contacts from 'stores/contacts2'

const LIMIT = 20

export default {
  components: {
    AddModal,
    DataTable,
    Column
  },
  props: {
    tenant: {
      type: Object,
      required: true
    },
    user: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      loading: true,
      load_params: {skip: 0, limit: LIMIT, filter: '', user_id: this.user.id},
    }
  },
  computed: {
    total(){
      return $contacts.total
    },
    view_items(){
      return $contacts.view_items
    },
    view_total(){
      return $contacts.view_total
    },
    refreshing() {
      return $contacts.loading
    },
    highlight () {
      return this.load_params.filter
    }
  },
  async mounted() {
    this.loading = true
    await $contacts.load(this.load_params)
    this.loading = false
  },
  methods: {
    async onPage(ev){
      this.load_params = {...this.load_params, skip: ev.first, limit: ev.rows}
      await $contacts.load(this.load_params)
    },
    async onCopyId(id) {
      await $utils.copyText(id)
    },
    async onSearch(filter){
      if (this.load_params.filter === filter) return
      this.load_params = {skip: 0, limit: LIMIT, filter, user_id: this.user.id}
      await $contacts.load(this.load_params)
      this.$refs.search.focus()
    },
    onAddContact() {
      this.$refs.addModal.open(this.user.id)
    },
    async onNewContact(data) {
      const payload = {
        linkedin_id: data.chosen_contact.linkedin_id,
        company_linkedin_id: data.chosen_company.linkedin_id,
        user_id: this.user.id,
      }

      try {
        await $contacts.newContact(payload)
        await $contacts.load(this.load_params)
        $utils.toasts.success('User contact added successfully')
      }
      catch(err) {
        $utils.toasts.error(`Failed to add contact: ${err}`)
      }
      this.$refs.addModal.close(true)
    },
    async onRemoveContact(id) {
      const cont = await $contacts.getContact(id)
      await cont.drop(this.user.id)
      await $contacts.load(this.load_params)
    },
  }
}
